const state = {
  message: null,
};

const mutations = {
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  CLEAR_MESSAGE(state) {
    state.message = null;
  }
};

const actions = {
  setMessage({ commit }, message) {
    commit("SET_MESSAGE", message);
  },
  setMessageWithTimeout({ commit }, data) {
    commit("SET_MESSAGE", data.message);
    setTimeout(() => {
      commit("CLEAR_MESSAGE");
    }, data.time);
  },
  clearMessage({ commit }) {
    commit("CLEAR_MESSAGE");
  },

};

const getters = {
  getMessage(state) {
    return state.message;
  },
  getShowMessage(state) {
    if (state.message === null) {
      return false;
    }
    
    return true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Message.js